import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core'
import * as moment from 'moment';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
  currentYear: any = moment();
  constructor(public translate: TranslateService) { }

  changeLang(language: string) {  
    localStorage.setItem('locale', language);  
    this.translate.use(language);  
  } 

  ngOnInit() {
    this.currentYear = moment().format('YYYY');
    //console.log('XXXX',this.currentYear)
  }

}
